import {getRandomColor} from "../../../utils/GetRandomColor";

export default function Algebra() {
    const referencesStyle = {
        textAlign: "left",
    }
    
    return (
        <div className={"blog-body"}>
            <ol style={referencesStyle}>
                <li>
                    AlphaZero: Shedding new light on the grand games of chess, shogi and Go. (n.d.). Retrieved
                    2022-01-09, from <a style={{backgroundColor: getRandomColor()}}
                        href="https://deepmind.com/blog/article/alphazero-shedding-new-light-grand-games-chess-shogi-and-go">https://deepmind.com/blog/article/alphazero-shedding-new-light-grand-games-chess-shogi-and-go</a>
                </li>

                <li>
                    Arsht, E. (2019, April). Napoleon was the best general ever, and the math proves it.
                    Retrieved
                    2022-01-05, from <a style={{backgroundColor: getRandomColor()}}
                        href="https://towardsdatascience.com/napoleon-was-the-best-general-ever-and-the-math-proves-it-86efed303eeb">https://towardsdatascience.com/napoleon-was-the-best-general-ever-and-the-math-proves-it-86efed303eeb</a>
                </li>

                <li>
                    Bayes’ theorem. (2022). Retrieved 2022-06-12, from <a style={{backgroundColor: getRandomColor()}}
                        href="https://corporatefinanceinstitute.com/resources/knowledge/other/bayes-theorem/">https://corporatefinanceinstitute.com/resources/knowledge/other/bayes-theorem/</a>
                </li>

                <li>
                    Bloomfield, P. (2004). Fourier analysis of time series: an introduction. John Wiley & Sons.
                </li>

                <li>
                    Brownlee, J., Cristina, S., & Saeed, M. (2022). Calculus for machine learning. Machine
                    Learning
                    Mastery.
                </li>

                <li>
                    Cao, L. (2017). Data science: a comprehensive overview. ACM Computing Surveys (CSUR), 50(3),
                    1-42.
                </li>

                <li>
                    DasGupta, A. (2011). Probability for statistics and machine learning: fundamentals and
                    advanced
                    topics. Springer.
                </li>

                <li>
                    Diggle, P. J. (2015). Statistics: a data science for the 21st century. Journal of the Royal
                    Statistical Society: Series A (Statistics in Society), 178(4), 793–813.
                </li>

                <li>
                    Garding, L., & Tambour, T. (2012). Algebra for computer science. Springer Science & Business
                    Media.
                </li>

                <li>
                    Glorot, X., & Bengio, Y. (2010). Understanding the difficulty of training deep feedforward
                    neural networks. In Proceedings of the thirteenth international conference on artificial
                    intelligence and statistics (pp. 249-256).
                </li>

                <li>
                    Gustafsen, A. (2022, March). The confusion matrix in hypothesis testing. Retrieved
                    2022-06-15,
                    from <a style={{backgroundColor: getRandomColor()}}
                        href="https://towardsdatascience.com/the-confusion-matrix-explained-part-1-5513c6f659c1">https://towardsdatascience.com/the-confusion-matrix-explained-part-1-5513c6f659c1</a>
                </li>

                <li>
                    Holbrook, R. (2021). Time series tutorials. Retrieved 2022-06-03, from <a style={{backgroundColor: getRandomColor()}} href="https://www.kaggle.com/learn/time-series">https://www.kaggle.com/learn/time-series</a>
                </li>

                <li>
                    Kan, E. (2021, August). Quick ml concepts: tensors. Retrieved 2022-06-16, from <a style={{backgroundColor: getRandomColor()}}
                        href="https://towardsdatascience.com/quick-ml-concepts-tensors-eb1330d7760f">https://towardsdatascience.com/quick-ml-concepts-tensors-eb1330d7760f</a>
                </li>

                <li>
                    Kumar, P. (2021, June). Time complexity of ml models. Retrieved 2022-06-17, from <a style={{backgroundColor: getRandomColor()}}
                        href="https://medium.com/analytics-vidhya/time-complexity-of-ml-models-4ec39fad2770">https://medium.com/analytics-vidhya/time-complexity-of-ml-models-4ec39fad2770</a>
                </li>

                <li>
                    Lydia, A., & Francis, S. (2019). Adagrad—an optimizer for stochastic gradient descent. Int.
                    J.
                    Inf. Comput. Sci, 6(5), 566-568
                </li>

                <li>
                    Okewu, E., Misra, S., & Lius, F.-S. (2020). Parameter tuning using adaptive moment
                    estimation in
                    deep learning neural networks. In International conference on computational science and its
                    applications (pp. 261-272).
                </li>

                <li>
                    Rajendran, P. K., Asbern, A., Kumar, K. M., Rajesh, M., & Abhilash, R. (2016).
                    Implementation
                    and analysis of mapreduce on biomedical big data. Indian Journal of Science and Technology,
                    9(31).
                </li>

                <li>
                    Raju, T. N. (2005). William sealy gosset and william a. silverman: two “students” of
                    science.
                    Pediatrics, 116(3), 732-735.
                </li>

                <li>
                    Rosenthal, A. (1951). The history of calculus. The American Mathematical Monthly, 58(2),
                    75-86.
                </li>

                <li>
                    Shafi. (2020, October). Ai & mathematics. Retrieved 2022-06-18, from <a style={{backgroundColor: getRandomColor()}}
                        href="https://medium.com/swlh/ai-mathematics-699a9ea2a0d6">https://medium.com/swlh/ai-mathematics-699a9ea2a0d6</a>
                </li>

                <li>
                    Steinke, S. (2017, August). What’s the difference between a matrix and a tensor? Retrieved
                    2022-06-17, from <a style={{backgroundColor: getRandomColor()}}
                        href="https://medium.com/@quantumsteinke/whats-the-difference-between-a-matrix-and-a-tensor-4505fbdc576c">https://medium.com/@quantumsteinke/whats-the-difference-between-a-matrix-and-a-tensor-4505fbdc576c</a>
                </li>

                <li>
                    The Editors of Encyclopaedia Britannica. (2020). Digital computer | evolution, components, &
                    features | britannica. Retrieved 2022-06-17, from <a style={{backgroundColor: getRandomColor()}}
                        href="https://www.britannica.com/technology/digital-computer">https://www.britannica.com/technology/digital-computer</a>
                </li>

                <li>
                    vartika02. (2019, January). 5 V’s of Big Data. Retrieved 2021-12-29, from <a style={{backgroundColor: getRandomColor()}}
                        href="https://www.geeksforgeeks.org/5-vs-of-big-data/">https://www.geeksforgeeks.org/5-vs-of-big-data/</a>
                </li>

                <li>
                    Xu, D., & Tian, Y. (2015). A comprehensive survey of clustering algorithms. Annals of Data
                    Science, 2(2), 165-193.
                </li>
            </ol>
        </div>
    )
}